import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import ErrorPage from "@/pages/ErrorPage";

export default function RouteErrorPage() {
  const error = useRouteError();
  const status = isRouteErrorResponse(error) ? error.status : 500;

  if (status === 404) {
    return <ErrorPage code={404} />;
  }

  return (
    <ErrorPage code={500} variant="route_error" />
  );
}
